import { render } from "./MeusPedidos.vue?vue&type=template&id=82c6f232&scoped=true"
import script from "./MeusPedidos.vue?vue&type=script&lang=js"
export * from "./MeusPedidos.vue?vue&type=script&lang=js"

import "./MeusPedidos.vue?vue&type=style&index=0&id=82c6f232&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c6f232"]])

export default __exports__